<template>
  <div id="lom-list" class="jci-report-page">
    <v-overlay :value="DeleteLoadingFlag" z-index="999">
      <v-progress-circular
        indeterminate
        size="64"
        color="#0097D7"
        width="5"
      ></v-progress-circular>
    </v-overlay>

    <!-- Main Outer Card -->
    <v-card class="elevation-6 jci-main-card">
      <!-- Top Gold-Seafoam Accent Bar -->
      <div class="jci-top-accent-bar"></div>

      <!-- Hero Header Banner -->
      <div
        class="jci-header-banner px-6 py-6 d-flex align-center justify-space-between flex-wrap gap-4"
      >
        <div class="d-flex align-center">
          <div class="jci-header-icon-box mr-4">
            <v-icon size="32" color="#FFFFFF">mdi-file-document</v-icon>
          </div>
          <div>
            <div class="mb-1">
              <h1 class="jci-page-title">{{ PageTitle }}</h1>
            </div>
            <p class="jci-page-subtitle mb-0">{{ PageDescription }}</p>
          </div>
        </div>
      </div>

      <!-- Floating Speed Dial -->
      <v-container class="py-0" v-if="tableOptions1.FloatingButtonFlag">
        <v-speed-dial
          v-model="fab"
          :top="top"
          :bottom="bottom"
          :right="right"
          :left="left"
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
          :fixed="true"
        >
          <template v-slot:activator>
            <v-btn
              v-model="fab"
              color="#3A67B1"
              dark
              fab
              class="elevation-8 jci-fab-main"
            >
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                color="#3A67B1"
                @click.prevent="addRecord"
                v-if="tableOptions1.CreateButtonFlag"
                v-bind="attrs"
                v-on="on"
                class="jci-fab-item"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Create</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                color="#0097D7"
                @click.prevent="TransferData"
                v-if="tableOptions1.TransferFlag"
                v-bind="attrs"
                v-on="on"
                class="jci-fab-item"
              >
                <v-icon>mdi-repeat</v-icon>
              </v-btn>
            </template>
            <span>Transfer</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                color="#56BDA3"
                v-if="tableOptions1.PreviewButtonFlag"
                @click.prevent="previewData"
                v-bind="attrs"
                v-on="on"
                class="jci-fab-item"
              >
                <v-icon>mdi-file-search</v-icon>
              </v-btn>
            </template>
            <span>Preview</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                color="#EDBE38"
                v-if="tableOptions1.EditButtonFlag"
                @click.prevent="editData"
                v-bind="attrs"
                v-on="on"
                class="jci-fab-item"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                color="#E53935"
                v-if="tableOptions1.DeleteButtonFlag"
                @click.prevent="deleteDataAlert"
                v-bind="attrs"
                v-on="on"
                class="jci-fab-item"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-speed-dial>
      </v-container>

      <!-- Dialogs -->
      <v-dialog v-model="previewRecordPrompt" max-width="75%">
        <foundation-payment-preview
          PageTitle="Foundation Payment Details"
          :previewRecordPrompt="previewRecordPrompt"
          @hidePreviewRecordPrompt="hidePreviewRecordPrompt"
          :recordData="selectedData"
          v-if="previewRecordPrompt"
        ></foundation-payment-preview>
      </v-dialog>

      <v-dialog v-model="TransferRecordPrompt" max-width="75%">
        <foundation-title-transfer
          pageTitle="Foundation Payment Transfer"
          :TransferRecordPrompt="TransferRecordPrompt"
          @hideTransferRecordPrompt="hideTransferRecordPrompt"
          :recordData="selected"
          v-if="TransferRecordPrompt"
        ></foundation-title-transfer>
      </v-dialog>

      <v-dialog v-model="editRecordPrompt" max-width="75%">
        <manual-foundation-payment-edit
          PageTitle="Manual Foundation Payment Edit"
          :previewRecordPrompt="editRecordPrompt"
          @hidePreviewRecordPrompt="hideEditRecordPrompt($event)"
          :recordData="selectedData"
          v-if="editRecordPrompt"
        ></manual-foundation-payment-edit>
      </v-dialog>

      <v-card-text class="pt-6 px-6">
        <!-- Loading Spinner -->
        <div class="d-flex justify-content-center my-4" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
            style="color: #3a67b1 !important"
          ></b-spinner>
        </div>

        <!-- Filter Container Card -->
        <div class="jci-filter-card mb-6 pa-5">
          <div
            class="d-flex align-center justify-space-between mb-4 pb-2 jci-filter-header-border"
          >
            <div class="d-flex align-center">
              <div class="jci-filter-icon-pill mr-3">
                <v-icon size="22" color="#3A67B1">mdi-filter-variant</v-icon>
              </div>
              <div>
                <h3 class="jci-filter-title mb-0">Search & Filter Criteria</h3>
                <span class="jci-filter-subtitle"
                  >Specify your parameters to query receipts</span
                >
              </div>
            </div>
          </div>

          <v-form ref="form2" v-model="valid1" lazy-validation>
            <v-row wrap class="mt-1">
              <v-col cols="12" md="3">
                <label class="jci-form-label"
                  ><span class="text-danger">*</span> Search Type</label
                >
                <v-select
                  :reduce="(option) => option.value"
                  :items="SearchIdOptions"
                  :rules="SearchIdRules"
                  v-model="SearchId"
                  required
                  outlined
                  dense
                  class="jci-input"
                ></v-select>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 1">
                <label class="jci-form-label">
                  Zone
                  <small class="jci-optional-text">(optional)</small>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  v-model="ZoneCode"
                  :rules="ZoneCodeRules"
                  :items="ZoneCodeOptions"
                  :loading="ZoneCodeOptionsLoading"
                  dense
                  clearable
                  required
                  outlined
                  class="jci-input"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 1">
                <label class="jci-form-label">
                  LO
                  <small class="jci-optional-text">(optional)</small>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  v-model="LomCode"
                  :rules="LomCodeRules"
                  :items="LomCodeOptions"
                  :loading="LomCodeOptionsLoading"
                  dense
                  clearable
                  required
                  outlined
                  class="jci-input"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 2">
                <label class="jci-form-label"
                  ><span class="text-danger">*</span> LMC Register Number</label
                >
                <v-text-field
                  v-model="RegisterNo"
                  :rules="RegisterNoRules"
                  hint="Enter LMC Register number"
                  required
                  outlined
                  dense
                  class="jci-input"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 3">
                <label class="jci-form-label"
                  ><span class="text-danger">*</span> Razorpay payment id</label
                >
                <v-text-field
                  v-model="PaymentId"
                  :rules="PaymentIdRules"
                  hint="Enter razorpay payment id"
                  required
                  outlined
                  dense
                  class="jci-input"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 4">
                <label class="jci-form-label"
                  ><span class="text-danger">*</span> Membership id</label
                >
                <v-text-field
                  v-model="MembershipId"
                  :rules="MembershipIdRules"
                  hint="Enter Membership id"
                  required
                  outlined
                  dense
                  class="jci-input"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 1">
                <label class="jci-form-label"
                  >Transaction Type
                  <small class="jci-optional-text">(optional)</small></label
                >
                <v-select
                  :reduce="(option) => option.value"
                  :items="TransactionTypeIdOptions"
                  :rules="TransactionTypeIdRules"
                  v-model="TransactionTypeId"
                  required
                  outlined
                  dense
                  class="jci-input"
                ></v-select>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 1">
                <label class="jci-form-label">From Date</label>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="FromDate"
                      label="From Date"
                      readonly
                      v-on="on"
                      outlined
                      dense
                      class="jci-input"
                      append-icon="mdi-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="FromDate"
                    color="#3A67B1"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="3" v-if="SearchId == 1">
                <label class="jci-form-label">To Date</label>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="ToDate"
                      label="To Date"
                      readonly
                      v-on="on"
                      outlined
                      dense
                      class="jci-input"
                      append-icon="mdi-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="ToDate"
                    color="#3A67B1"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row wrap class="mt-3">
              <v-col align="center" cols="12">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="searchForm"
                  :loading="SearchFlag"
                  large
                  class="jci-search-btn"
                >
                  <v-icon left size="20">mdi-magnify</v-icon>
                  Search Records
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>

        <!-- Results Found Banner -->
        <v-fade-transition>
          <div
            class="jci-results-counter-bar mb-5 px-5 py-3 d-flex align-center justify-space-between"
            v-if="ResultFlag"
          >
            <div class="d-flex align-center">
              <div class="jci-counter-icon mr-3">
                <v-icon color="#0097D7" small>mdi-database</v-icon>
              </div>
              <span class="jci-records-text font-weight-bold"
                >{{ rows.length }} records found</span
              >
            </div>
          </div>
        </v-fade-transition>

        <!-- Actions & Table Section -->
        <v-fade-transition>
          <div v-if="ResultFlag && rows.length > 0" class="jci-table-section">
            <!-- Action Export Buttons -->
            <div
              class="d-flex flex-wrap align-center justify-center gap-3 mb-6"
            >
              <v-btn
                v-if="tableOptions1.ExcelDownloadFlag"
                @click.prevent="generateReportExcel"
                :loading="ExcelLoadingFlag"
                target="_blank"
                class="jci-btn jci-btn-gold"
              >
                <v-icon left dark small>mdi-file-excel</v-icon>
                Generate Report
              </v-btn>

              <v-btn
                v-if="ExcelFileName != '' && ExcelDownloadFlag == 1"
                :href="ExcelFileName"
                target="_blank"
                class="jci-btn jci-btn-seafoam"
              >
                <v-icon left dark small>mdi-download</v-icon> Download Report
              </v-btn>

              <v-btn
                class="jci-btn jci-btn-aqua"
                v-if="
                  rows.length > 0 &&
                  tableOptions1.JsonDownloadButtonFlag == true
                "
                @click.prevent="
                  generateExcel(
                    rows,
                    tableOptions1.JsonExcelFields,
                    tableOptions1.ExcelFileName,
                    'My Worksheet'
                  )
                "
              >
                <v-icon left dark small>mdi-file-download</v-icon>
                Download Data
              </v-btn>
            </div>

            <!-- Table Container -->
            <div class="jci-table-card pa-4">
              <div
                class="d-flex justify-space-between align-center mb-4 flex-wrap gap-3"
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search records in table..."
                  single-line
                  hide-details
                  outlined
                  dense
                  class="jci-table-search-input"
                ></v-text-field>
              </div>

              <v-data-table
                class="elevation-0 jci-custom-table"
                v-model="selected"
                :loading="SearchFlag"
                loading-text="Loading... Please wait"
                :headers="tableColumns1"
                :items="rows"
                :search="search"
                :items-per-page="tableOptions1.ItemsPerPage"
                :item-key="tableOptions1.ItemKey"
                :single-select="tableOptions1.SingleSelectFlag"
                :show-select="tableOptions1.ShowSelectFlag"
                :footer-props="tableOptions1.FooterProps"
              >
                <template v-slot:item.ActiveStatusTxt="{ item }">
                  <v-chip
                    :color="getActiveStatusColor(item.ActiveStatusTxt)"
                    draggable
                    dark
                    small
                    class="font-weight-medium px-3"
                    >{{ item.ActiveStatusTxt }}</v-chip
                  >
                </template>

                <template v-slot:item.ProfilePic="{ item }">
                  <img
                    width="46"
                    height="46"
                    class="rounded-circle jci-avatar-img"
                    :src="item.ProfilePic"
                  />
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="d-flex align-center">
                    <v-tooltip
                      bottom
                      v-if="item.ReceiptFilePath && item.ReceiptFilePath !== ''"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-1 jci-action-icon-btn"
                          icon
                          small
                          color="#E53935"
                          @click="downloadReceiptPdf(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon small>mdi-file-pdf</v-icon>
                        </v-btn>
                      </template>
                      <span>Download Receipt PDF</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="#3A67B1"
                          class="mx-1 jci-action-icon-btn"
                          @click="previewData(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon small>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="#0097D7"
                          class="mx-1 jci-action-icon-btn"
                          @click="editData(item)"
                          v-bind="attrs"
                          v-on="on"
                          v-if="item.ActiveStatusTxt == 2"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-fade-transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import FoundationPaymentPreview from "@/view/pages/erp/reports/FoundationPayment/FoundationPaymentPreview.vue";
import FoundationTitleTransfer from "@/view/pages/erp/reports/FoundationPayment/FoundationTitleTransfer.vue";
import ManualFoundationPaymentEdit from "@/view/pages/erp/reports/FoundationPayment/ManualFoundationPaymentEdit.vue";

export default {
  mixins: [common],
  components: {
    FoundationPaymentPreview,
    FoundationTitleTransfer,
    ManualFoundationPaymentEdit,
  },
  data() {
    return {
      valid1: true,
      valid2: true,

      DeleteLoadingFlag: false,
      LoadingFlag: false,
      ResultFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      rows: [],
      tableColumns1: [],
      tableOptions1: {},
      selected: [],
      selectedData: {},
      search: "",
      CurrentYearId: "",

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      zone: {},
      lom: {},

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By Date" },
        { value: 2, text: "By LMC Register number" },
        { value: 3, text: "By Razorpay Payment id" },
        { value: 4, text: "By Membership id" },
      ],

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      TransactionTypeId: "",
      TransactionTypeIdRules: [],
      // (v) => !!v || "Transaction Type is required"
      TransactionTypeIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "Online" },
        { value: 2, text: "Manual" },
      ],

      RegisterNo: "",
      RegisterNoRules: [(v) => !!v || "LMC Register number is required"],

      PaymentId: "",
      PaymentIdRules: [(v) => !!v || "Payment id is required"],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership id is required"],

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      TransferRecordPrompt: false,

      ExcelDownloadFlag: false,
      ExcelLoadingFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.getZoneCodeOptions();
      }
    },
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCode = "";
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      this.LomCode = "";
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
      this.LomCode = "";
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    TransferData() {
      console.log("TransferData called");
      // var tr = this.selected
      // var n1 = tr.length
      var selectedData = this.selected;
      var n1 = selectedData.length;

      console.log(
        "n1=" + n1 + ", selectedData=" + JSON.stringify(selectedData)
      );
      if (n1 > 0) {
        this.selected = selectedData[0];
        this.TransferRecordPrompt = true;
      } else {
        var message = "Kindly select one record to Transfer";
        this.toast("error", message);
      }
    },
    hideTransferRecordPrompt() {
      console.log("hideTransferRecordPrompt called");
      this.TransferRecordPrompt = false;
      this.searchForm();
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/lmc/title/contribution-payment";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      console.log("YearCode=" + YearCode + ", ZoneCode=" + ZoneCode);
      if (YearCode != "" && ZoneCode != "") {
        this.LomCode = "";
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
          AllOption: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    editData(item) {
      var selectedData =
        item &&
        typeof item === "object" &&
        !item.target &&
        Object.keys(item).length > 0
          ? [item]
          : this.selected;
      console.log("editData called");
      var n1 = selectedData.length;
      console.log({ selectedData });
      var message = "";
      if (n1 > 0) {
        var tr = selectedData[0];
        console.log({ tr });
        var TransactionTypeId = tr.TransactionTypeId;
        console.log({ TransactionTypeId });
        if (TransactionTypeId == 2) {
          this.editRecordPrompt = true;
          this.selectedData = tr;
        } else {
          message = "You can not edit Online title payment";
          this.sweetAlert("error", message, false);
        }
      } else {
        message = "Kindly select one member to edit";
        this.sweetAlert("error", message, true);
      }
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      console.log({ flag });
      this.editRecordPrompt = false;
      this.selected = [];
      if (flag) {
        this.searchForm();
      }
    },
    previewData(item) {
      var selectedData =
        item &&
        typeof item === "object" &&
        !item.target &&
        Object.keys(item).length > 0
          ? [item]
          : this.selected;
      console.log("previewData called");
      var n1 = selectedData.length;
      console.log({ selectedData });
      if (n1 > 0) {
        var tr = selectedData[0];
        console.log({ tr });
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
      this.selected = [];
    },
    downloadReceiptPdf(item) {
      console.log("downloadReceiptPdf called", item);
      if (item && item.ReceiptFilePath && item.ReceiptFilePath !== "") {
        window.open(item.ReceiptFilePath, "_blank");
      } else {
        this.toast("error", "Receipt PDF is not available for this record");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "foundation_payment",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form2.validate();
      var FromDate = this.FromDate;
      var ToDate = this.ToDate;
      console.log(
        "validate1=" +
          validate1 +
          ", FromDate=" +
          FromDate +
          ", ToDate=" +
          ToDate
      );

      if (validate1) {
        this.SearchFlag = true;
        this.rows = [];
        this.selected = [];
        this.selectedData = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lmc/title-payment/lists";
        var upload = {
          SearchType: this.SearchId,
          RegisterNo: this.RegisterNo,
          TransactionType: this.TransactionTypeId,
          FromDate: this.FromDate,
          ToDate: this.ToDate,
          PaymentId: this.PaymentId,
          Zone: this.ZoneCode,
          Lom: this.LomCode,
          MembershipId: this.MembershipId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;
            thisIns.ResultFlag = true;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            // thisIns.ExcelFields = records.ExcelFields;
            // thisIns.ExcelFileName = records.ExcelFileName;

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableOptions1 = records.TableOptions;
              thisIns.rows = records.TableData;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
      // this.generateReportExcel();
    },
    deleteDataAlert() {
      console.log("deleteDataAlert called");
      var tr = this.selected;
      var n1 = tr.length;
      //   var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr[0];
        this.confirmAlert();
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");
      //   var validate1 = this.$refs.form1.validate();
      //   console.log("validate1=" + validate1);
      var tr = this.selectedData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "Member Name <b> " + tr.MemberName + "</b>";
        htmlTxt += "<br/> Title <b> " + tr.TitleName + "</b>";
        htmlTxt += "<br/> LMC Register No <b> " + tr.RegisterNo + "</b>";
        htmlTxt += "<br/><br/>Do you want to delete the data?";
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the data?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteData();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
    deleteData() {
      console.log("deleteData is called");

      var tr = this.selectedData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.DeleteLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lmc/title-payment/delete";
        var upload = {
          UserInterface: 1,
          MemberName: tr.TMRelationId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.SearchFlag = false;
            // thisIns.ResultFlag = true;
            thisIns.DeleteLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.selectedData = {};
              thisIns.selected = [];
              thisIns.searchForm();
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.DeleteLoadingFlag = false;
          });
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
    generateReportExcel() {
      console.log("generateReportExcel is called");

      var validate1 = this.$refs.form2.validate();
      var FromDate = this.FromDate;
      var ToDate = this.ToDate;
      console.log(
        "validate1=" +
          validate1 +
          ", FromDate=" +
          FromDate +
          ", ToDate=" +
          ToDate
      );

      if (validate1) {
        this.ExcelFileName = "";
        this.ExcelLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/reports/receipt/excel/export";
        var upload = {
          UserInterface: 2,
          ZoneCode: this.ZoneCode,
          FromDate: this.FromDate,
          ToDate: this.ToDate,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()

            thisIns.ExcelLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ExcelFileName = records.ExcelFileName;
              thisIns.ExcelDownloadFlag = records.ExcelDownloadFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
            thisIns.ExcelLoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
  },
  mounted() {
    // this.searchForm();
  },
  beforeMount() {
    var todayDate = new Date().toISOString().slice(0, 10);
    console.log(todayDate);

    this.FromDate = todayDate;
    this.ToDate = todayDate;

    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* Ultra-Premium JCI Design System */

#lom-list {
  color: #414042;
  font-family: inherit;

  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }

  .jci-main-card {
    border-radius: 20px !important;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 16px 40px rgba(10, 15, 41, 0.07) !important;
    border: 1px solid rgba(58, 103, 177, 0.15) !important;
  }

  .jci-top-accent-bar {
    height: 4px;
    background: linear-gradient(
      90deg,
      #edbe38 0%,
      #56bda3 40%,
      #0097d7 70%,
      #3a67b1 100%
    );
  }

  .jci-header-banner {
    background: linear-gradient(135deg, #0a0f29 0%, #3a67b1 50%, #0097d7 100%);
    color: #ffffff;
    position: relative;
    box-shadow: 0 6px 20px rgba(10, 15, 41, 0.15);
  }

  .jci-header-icon-box {
    width: 56px;
    height: 56px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  }

  .jci-page-title {
    font-size: 1.6rem;
    font-weight: 800;
    color: #ffffff;
    letter-spacing: -0.02em;
    margin: 0;
  }

  .jci-header-tag {
    background: rgba(237, 190, 56, 0.25);
    border: 1px solid rgba(237, 190, 56, 0.6);
    color: #edbe38;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 20px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .jci-page-subtitle {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.88);
    font-weight: 400;
  }

  .jci-filter-card {
    background: #ffffff;
    border: 1px solid rgba(58, 103, 177, 0.14);
    border-radius: 16px;
    box-shadow: 0 8px 25px rgba(10, 15, 41, 0.03);
  }

  .jci-filter-header-border {
    border-bottom: 1px dashed #e2e8f0;
  }

  .jci-filter-icon-pill {
    width: 38px;
    height: 38px;
    background: rgba(58, 103, 177, 0.08);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jci-filter-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #0a0f29;
  }

  .jci-filter-subtitle {
    font-size: 0.825rem;
    color: #718096;
  }

  .jci-form-label {
    display: block;
    font-size: 0.825rem;
    font-weight: 700;
    color: #414042;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  .jci-optional-text {
    color: #a0aec0;
    font-weight: 400;
    text-transform: none;
  }

  .jci-input {
    .v-input__control {
      .v-input__slot {
        background-color: #f8fafc !important;
        border-radius: 10px !important;
        transition: background-color 0.2s, border-color 0.2s;
        border: 1px solid #e2e8f0 !important;

        &:hover {
          background-color: #ffffff !important;
        }
      }
    }
  }

  .jci-search-btn {
    background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%) !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    font-size: 0.95rem !important;
    letter-spacing: 0.4px;
    border-radius: 12px !important;
    padding: 0 42px !important;
    height: 48px !important;
    box-shadow: 0 8px 24px rgba(0, 151, 215, 0.35) !important;
    transition: all 0.25s ease-in-out;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 28px rgba(0, 151, 215, 0.45) !important;
    }
  }

  .jci-results-counter-bar {
    background: rgba(0, 151, 215, 0.06);
    border: 1px solid rgba(0, 151, 215, 0.2);
    border-radius: 12px;

    .jci-counter-icon {
      width: 32px;
      height: 32px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 6px rgba(0, 151, 215, 0.15);
    }

    .jci-records-text {
      color: #0a0f29;
      font-size: 1rem;
    }

    .jci-live-badge {
      font-size: 0.75rem;
      font-weight: 700;
      color: #56bda3;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      background: rgba(86, 189, 163, 0.12);
      padding: 4px 10px;
      border-radius: 12px;
    }
  }

  .gap-3 {
    gap: 14px;
  }

  .jci-btn {
    font-weight: 700 !important;
    border-radius: 10px !important;
    text-transform: none !important;
    letter-spacing: 0.3px;
    padding: 0 24px !important;
    height: 42px !important;
    transition: all 0.2s ease;

    &.jci-btn-gold {
      background-color: #edbe38 !important;
      color: #0a0f29 !important;
      box-shadow: 0 4px 14px rgba(237, 190, 56, 0.35) !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(237, 190, 56, 0.45) !important;
      }
    }

    &.jci-btn-seafoam {
      background-color: #56bda3 !important;
      color: #ffffff !important;
      box-shadow: 0 4px 14px rgba(86, 189, 163, 0.35) !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(86, 189, 163, 0.45) !important;
      }
    }

    &.jci-btn-aqua {
      background-color: #0097d7 !important;
      color: #ffffff !important;
      box-shadow: 0 4px 14px rgba(0, 151, 215, 0.35) !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(0, 151, 215, 0.45) !important;
      }
    }
  }

  .jci-table-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(10, 15, 41, 0.02);
  }

  .jci-table-search-input {
    max-width: 340px;

    .v-input__slot {
      border-radius: 10px !important;
      background-color: #f8fafc !important;
      border: 1px solid #e2e8f0 !important;
    }
  }

  .jci-custom-table {
    border-radius: 10px;
    overflow: hidden;

    table {
      thead {
        tr {
          th {
            background-color: #0a0f29 !important;
            color: #ffffff !important;
            font-size: 0.8rem !important;
            font-weight: 700 !important;
            text-transform: uppercase;
            letter-spacing: 0.6px;
            border-bottom: 3px solid #0097d7 !important;
            padding-top: 14px !important;
            padding-bottom: 14px !important;
          }
        }
      }

      tbody {
        tr {
          transition: background-color 0.15s ease;

          &:hover {
            background-color: rgba(0, 151, 215, 0.04) !important;
          }
        }
      }
    }
  }

  .jci-avatar-img {
    object-fit: cover;
    border: 2px solid #0097d7;
    box-shadow: 0 3px 8px rgba(0, 151, 215, 0.2);
  }

  .jci-action-icon-btn {
    transition: transform 0.15s ease, background-color 0.15s ease;

    &:hover {
      transform: scale(1.15);
      background-color: rgba(58, 103, 177, 0.08) !important;
    }
  }

  .jci-fab-main {
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.45) !important;
  }

  .jci-fab-item {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2) !important;
  }
}
</style>